import { Result, err, ok } from "neverthrow"
import { appStatusBodyToUserIdentities, CloudToDeviceAppStatusBody, ZCloudToDeviceAppStatusBody } from "../redux/syncthunk/ZCloudToDevice"
import { FusionError, safeParseJson } from '@fusion-advantage/backcompat'
import { UserIdentities } from "@fusion-advantage/formlib"
import { CloudToDeviceBlobApiResponseId, CloudToDeviceBlobType, CloudToDeviceBlobUpnAll, selectCloudToDeviceBlob } from "../dal/ldbCloudToDeviceBlob"

export const selectAppStatus = async (): Promise<Result<CloudToDeviceAppStatusBody|null, FusionError>> => {
	const rSelect = await selectCloudToDeviceBlob({
		type: CloudToDeviceBlobType.ApiResponse,
		id: CloudToDeviceBlobApiResponseId.AppStatus,
		upn: CloudToDeviceBlobUpnAll,
	})
	if(rSelect.isErr()) {
		return err(rSelect.error)
	}
	if(!rSelect.value) {
		// if the user has not logged in yet,
		// this is not an error
		return ok(null)
	}
	const rParse = safeParseJson(rSelect.value.data, ZCloudToDeviceAppStatusBody)
	if(rParse.isErr()) {
		return err(rParse.error)
	}
	return ok(rParse.value)
}

export const selectAppStatusIdentities = async (): Promise<Result<UserIdentities|null, FusionError>> => {
	const rSelect = await selectAppStatus()
	if(rSelect.isErr()) {
		return err(rSelect.error)
	}
	if(!rSelect.value) {
		return ok(null)
	}
	return ok(appStatusBodyToUserIdentities(rSelect.value))
}
